<template>
    <div>
      <v-menu
        offset-y
        :close-on-click="true"
        :close-on-content-click="false"
         v-model="menuOpen">
        <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mx-2"
              color="white"
              @click="menuOpen = true"
              v-bind="attrs"
              v-on="on"
              large>
              {{icons.mdiBellRing}}
            </v-icon>
        </template>
        <v-card
          class="mx-auto"
          width="35vw"
          tile
        >
        <v-list
          style="max-height: 55vh"
          class="overflow-y-auto">
          <v-list-item-group>
            <v-list-item
              v-for="item in notificationList"
              :key="item._id"
              two-line>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ formatNotification(item.body) }}</v-list-item-subtitle>
                <v-list-item-subtitle class="caption grey--text">
                  {{ formatTimestamp(item.createdAt) }}
                </v-list-item-subtitle>
              </v-list-item-content>
                <v-list-item-action>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="notification-badge-read-more"
                    v-if="shouldShowReadMore(item)"
                    color="blue"
                    text
                    @click="openNotification(item)">
                    Read More
                  </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        </v-card>
      </v-menu>
      <NotificationDialog
      :notification="badgeAnnouncement"
      :notificationDialog="openDialogBox"
      @showNotificationDialog="closeNotification"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mdiBellRing, mdiEmailCheck } from '@mdi/js';
import {
  formatNotification,
  markNotificationRead,
  formatTimestamp,
  shouldShowReadMore,
} from './notificationUtil';
import NotificationDialog from './NotificationDialog.vue';

export default {
  name: 'NotificationBadge',
  components: {
    NotificationDialog,
  },
  data: () => ({
    icons: {
      mdiBellRing,
      mdiEmailCheck,
    },
    menuOpen: false,
    openDialogBox: false,
    badgeAnnouncement: {
      _id: ' ',
      title: ' ',
      body: ' ',
    },
  }),
  created() {
    this.loadBadgeAnnouncements();
  },
  computed: {
    ...mapState({
      notificationList: (state) => state.notifications.badgeAnnouncements || [],
    }),
  },
  methods: {
    ...mapActions('notifications', [
      'loadBadgeAnnouncements',
      'setBadgeAnnouncements',
    ]),
    formatNotification,
    formatTimestamp,
    shouldShowReadMore,
    markRead(message) {
      markNotificationRead(message);
    },
    openNotification(message) {
      this.openDialogBox = true;
      this.badgeAnnouncement = message;
    },
    closeNotification(val) {
      this.openDialogBox = val;
    },
  },
};
</script>
